import React, { Component } from 'react'
import { Row, Col, Select, Form, Table, Button, Drawer, Space, /*DatePicker, TimePicker,*/ notification, Spin, Input, Typography, Checkbox, InputNumber, Switch } from 'antd'
import { FilterOutlined, PrinterOutlined, LogoutOutlined, ArrowLeftOutlined, HomeOutlined } from '@ant-design/icons'
import confirmIcon from '../../assets/images/input-tick.svg'
import '../warehouse/index.css'
import './index.css'
import Http from '../../utils/http'
import Cookies from 'universal-cookie'
import { cloneDeep } from 'lodash'
import { pages as PAGE, constants, timezone } from '../../constants/constants'
import moment from 'moment'
import { logout, pageHandler, getCookie, COOKIE } from '../../utils/cookie'
import { weightCalculator } from '../../utils/common'
const { Option } = Select
const { Text } = Typography

//FORMAT AWB NO
function formatAWBNo(awb) {
  let result = ''
  if (awb) {
    var b = '-'
    var position = 3
    result = [awb.slice(0, position), b, awb.slice(position)].join('')
  }
  return result
}
function formatWeightString(usual_wgt, unit) {
  return `${(usual_wgt?.toFixed(1) || 0) + unit}`
}
function getTimeDifferenceInMinutes(difference) {
  if (difference) {
    return moment().diff(difference, 'minutes')
  } else return 0
}
class OfldDashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cookieInterval: null,
      visible: false,
      weight_unit: 'KG',
      station: new Cookies().get('station'),
      user_id: new Cookies().get('id'),
      timezone: new Cookies().get('timezone'),
      role: new Cookies().get('role'),
      logintype: getCookie(COOKIE.LOGINTYPE),
      timezone_cty: timezone.find((item) => item.value === new Cookies().get('station'))?.zone || 'America/New_York',
      clock: '',
      intervalID: null,
      page: 1,
      count: 25,
      offload_list: [],
      filteredData: [],
      systemParameters: [],
      defaultSystemParameters: [],
      prodPriorityData: [],
      stationsData: [],
      fleetData: [],
      exceptionList: [],
      hrs_to_fpe: '',
      workArea: '',
      wbCheck: false,
      nbCheck: false,
      rfsCheck: false,
      prodPrioCheck: false,
      is_assigned: true,
      is_not_assigned: true,
      is_local: false,
      is_transfer: false,
      is_dom: '',
      location: '',
      dest: [],
      locationList: [],
      prod_codes: [],
      prodCodeList: [],
      latestTimestamp: null,
      searchSelect: false,
      searchValue: '',
      wasSearched: false,

      tempHrs_to_fpe: '',
      tempWorkArea: '',
      tempWbCheck: false,
      tempNbCheck: false,
      tempRfsCheck: false,
      tempProdPrioCheck: false,
      tempIs_assigned: false,
      tempIs_not_assigned: false,
      tempIs_local: false,
      tempIs_transfer: false,
      tempIs_dom: '',
      temp_prod_codes: '',
      temp_location: '',
      awb_ids: [],

      only_booked: false,
      red_locations: [],
      amber_locations: [],
      amber_value: 0,
      fpe_value: 0,
      isListening: false,

      hiddenInterval: null,
      hiddenMoment: null,
      is_clearfilters: false,
      tableBodyFontSize: localStorage.getItem(`Buildup_${new Cookies().get('station')}`),
      defaultFontSize: 'clamp(14px,1.3vw,1.3vw)',
      book_pen: true,
      book_com: true,
      filterChecked: false,
      filterValue: '',
      switch: false
    }
    this._queue = []
    this._isBusy = false
  }
  //clock added to dashboard 
  clockTimerLogic = () => {
    this.setState({ clock: moment().tz(this.state.timezone_cty).format('DD MMM YYYY | hh:mm A') })
  }

  clockTimerInterval = () => {
    let clockInterval = setInterval(() => {
      this.clockTimerLogic()
    }, 60000)
    this.setState({ intervalID: clockInterval })
  }

  componentDidMount() {

    this.setState({ clock: moment().tz(this.state.timezone_cty).format('DD MMM YYYY | hh:mm A') }, () => {
      this.clockTimerLogic()
      this.clockTimerInterval()
    })

    pageHandler(window.location.pathname, getCookie(COOKIE.ROLE))
    this.setState({ cookieInterval: setInterval(this.checkInterval, 1000) })

    setInterval(() => this.setState({ hiddenInterval: this.handlePageVisibility() }), 10000)
    // this.fetchWorkAreas()
    this.setState({ loading: true, }, () => this.fetchFilters())

    // const buildupdashboard_events = new EventSource(process.env.REACT_APP_API_URL + `events?pgtype=od&stn=${this.state.station}`)
    // buildupdashboard_events.onmessage = (event) => {
    //   const parsedData = JSON.parse(event.data)
    //   if (!this.state.isListening) this.setState({ isListening: true })
    //   else {
    //     const myFakeAsyncJob = this.getFakeAsyncJob(parsedData)
    //     if (!this.state.wasSearched) {
    //       this.enqueue(myFakeAsyncJob)
    //     }
    //   }
    // }
  }

  componentDidUpdate() {
    const fontSize = localStorage.getItem(`Buildup_${new Cookies().get('station')}`)
    if (this.state.tableBodyFontSize !== fontSize) {
      this.setState({ tableBodyFontSize: fontSize })
    }
  }

  handlePageVisibility = () => {
    //HANDLE TAB VISIBILITY
    if (this.state.hiddenMoment === null && window.document.visibilityState === 'hidden') {
      this.setState({ hiddenMoment: moment().format('YYYY-MM-DD HH:mm:ss') })
    } else if (window.document.visibilityState === 'visible' && (this.state.hiddenMoment && getTimeDifferenceInMinutes(this.state.hiddenMoment) < 5)) {
      this.setState({ hiddenMoment: null })
    }
    if ((this.state.hiddenMoment && (getTimeDifferenceInMinutes(this.state.hiddenMoment) > 5)) && this._queue?.length > 80) {
      this.refreshPage()
    }
  }

  refreshPage = () => {
    let url = 'offload-dashboard'
    window.location.href = url
  }

  showDrawer = () => {
    this.setState({ visible: true, })
  }
  onClose = () => {
    this.setState({
      visible: false,
      hrs_to_fpe: this.state.tempHrs_to_fpe,
      workArea: this.state.tempWorkArea,
      wbCheck: this.state.tempWbCheck,
      nbCheck: this.state.tempNbCheck,
      rfsCheck: this.state.tempRfsCheck,
      prodPrioCheck: this.state.tempProdPrioCheck,
      is_assigned: this.state.tempIs_assigned,
      is_not_assigned: this.state.tempIs_not_assigned,
      is_local: this.state.tempIs_local,
      is_transfer: this.state.tempIs_transfer,
      is_dom: this.state.tempIs_dom,
      start: this.state.tempStart,
      end: this.state.tempEnd,
      stime: this.state.tempStime,
      etime: this.state.tempEtime,
    })
  }

  componentWillUnmount() {
    this.setState({
      cookieInterval: clearInterval(this.state.cookieInterval),
      hiddenInterval: clearInterval(this.state.hiddenInterval),
    })
  }

  /*************************************************************** */

  enqueue = (job) => {
    // we'll wrap the job in a promise and include the resolve and reject functions in the job we'll enqueue, so we can control when we resolve and execute them sequentially
    new Promise((resolve, reject) => {
      this._queue.push({
        job,
        resolve,
        reject
      })
    })
    // we'll add a nextJob function and call it when we enqueue a new job; we'll use _isBusy to make sure we're executing the next job sequentially
    this.nextJob()
  }
  nextJob = () => {
    if (this._isBusy) return
    const next = this._queue.shift()
    // if the array is empty shift() will return undefined
    if (next) {
      this.setState({ spinnerForEvents: true })
      this._isBusy = true
      next
        .job()
        .then((value) => {
          if (!this.state.wasSearched) {
            this.eventList(value)
          }
          next.resolve(value)
          this._isBusy = false
          this.nextJob()
        })
        .catch((error) => {
          this.setState({ spinnerForEvents: false })
          next.reject(error)
          this._isBusy = false
          this.nextJob()
        })
    } else {
      this.setState({ spinnerForEvents: false })
    }
  }
  getFakeAsyncJob = (item) => {
    return () =>
      new Promise((resolve) => {
        setTimeout(() => {
          resolve(item)
        }, 600)
      })
  }
  eventList = (parsedData) => {
    if (parsedData?.TYPE === 'AWB_OFLD_CLEAR') {
      this.handleAWBUpdate(parsedData?.DETAILS)
    }
    else if (parsedData?.TYPE === 'AWB_UPDATE' && (parsedData?.Msg?.includes('MAN') || parsedData?.Msg?.includes('FFM') || parsedData?.Msg?.includes('PRE'))) {
      this.handleAWBUpdate(parsedData?.DETAILS)
    } else if (parsedData?.TYPE === 'AWB_UPDATE' && parsedData?.Msg?.includes('DIS')) {
      this.FetchOffload()
    }
  }
  fetchIndividualFlightByAWBNo = async (ID) => {
    let headers = {
      station: this.state.station,
      page: PAGE.BUILDUP
    }
    let obj = null
    await Http.get(`dash_build_up_list?id=${ID}&booked_only=${this.state.only_booked}`, { headers }).then(resp => {
      if (resp?.status === 200) {
        if (resp?.data?.data?.goods?.length > 0) {
          obj = resp?.data?.data?.goods[0]
        }
      }
    })
    return obj
  }
  //FETCH INDIVIDUAL FLIGHT BY SEG ID
  fetchIndividualFlightBySegId = async (ID) => {
    let headers = {
      station: this.state.station,
      page: PAGE.BUILDUP
    }
    let obj = null
    await Http.get(`awb_seg?id=${ID}`, { headers }).then(resp => {
      if (resp?.status === 200) {
        if (resp?.data?.data) {
          obj = resp?.data?.data
        }
      }
    })
    return obj
  }
  //BOOKING UPDATE
  handleBookingUpdate = async (DETAILS, WORK_AREA, SEG_WORK_AREA) => {
    if (SEG_WORK_AREA) {
      let data = cloneDeep(this.state.offload_list)
      if (this.state.workArea?.toUpperCase() === SEG_WORK_AREA?.toUpperCase()) {
        let awb_index = data?.findIndex((p) => p?.id === parseInt(DETAILS?.seg_out) && p?.is_seg)
        if (awb_index > -1) {
          data?.splice(awb_index, 1)
          this.setState({ offload_list: [], }, () => this.setState({ offload_list: data }))
        }
      }
    }
    if (DETAILS?.goods_info_id) {
      let data = cloneDeep(this.state.offload_list)
      if (this.state.workArea?.toUpperCase() === WORK_AREA?.toUpperCase()) {
        let awb_index = data?.findIndex((p) => p?.id === parseInt(DETAILS?.goods_info_id) && !p?.is_seg)
        if (awb_index > -1) {
          this.fetchIndividualFlightByAWBNo(parseInt(DETAILS?.goods_info_id)).then((item) => {
            if (!this.state.wasSearched) {
              if (item) {
                awb_index = data?.findIndex((p) => p?.id === parseInt(DETAILS?.goods_info_id))
                if (awb_index > -1) {
                  if (item?.rdy) {
                    data?.splice(awb_index, 1)
                  } else {
                    data[awb_index] = this.processIndividualRow(item)
                  }
                  this.setState({ offload_list: [], }, () => this.setState({ offload_list: data }))
                }
              } else {
                awb_index = data?.findIndex((p) => p?.id === parseInt(DETAILS?.goods_info_id))
                if (awb_index > -1) {
                  data?.splice(awb_index, 1)
                  this.setState({ offload_list: [], }, () => this.setState({ offload_list: data }))
                }
              }
            }
          })
        } else {
          this.fetchIndividualFlightByAWBNo(parseInt(DETAILS?.goods_info_id)).then((item) => {
            if (!this.state.wasSearched) {
              if (item) {
                if ((this.state.only_booked && !item?.segs_out)) {
                  //DO NOTHING
                } else {
                  if (!item?.rdy) {
                    data.push(this.processIndividualRow(item))
                    this.setState({ offload_list: [], }, () => this.setState({ offload_list: data }))
                  }
                }
              }
            }
          })
        }
      }
    }
  }
  //AWB UPDATE EVENT
  handleAWBUpdate = (DETAILS) => {
    if (DETAILS?.id) {
      let data = cloneDeep(this.state.offload_list)
      let index = data?.findIndex((p) => p.id === parseInt(DETAILS?.id))
      if (index > -1) {
        this.setState({ awb_ids: [...this.state.awb_ids, parseInt(DETAILS?.id)] })
        setTimeout(() => {
          data.splice(index, 1)
          this.setState({ offload_list: data }, () => {
            this.filter()
          })
        }, 10000)
      }
    }
  }
  checkInterval = () => {
    let newCookie = new Cookies().get('weight')
    if (newCookie !== this.state.weight_unit) {
      this.setState({ weight_unit: newCookie })
    }
  }
  //FETCH USER FILTERS
  fetchFilters = async () => {
    await Http.get(`/page_filter/${this.state.user_id}`).then(async (data) => {
      if (data && data?.status === 200) {
        let res_data = data?.data?.data?.page_filters?.offloaddash_filter && data?.data?.data?.page_filters?.offloaddash_filter[this.state.station]
        if (res_data) {
          this.setState({
            dest: res_data?.dest || [],
            location: res_data?.location || [],
            prod_codes: res_data?.prod_codes || [],
            book_pen: res_data?.book_pen || true,
            book_com: res_data?.book_com || true,
            filterChecked: res_data?.filterChecked || false,
            filterValue: res_data?.filterValue || '',
            switch: res_data?.switch || false,
          })
        } else {
          this.setState({
            offloadFilter: data?.data?.data?.page_filters?.offloaddash_filter || {},
            dest: [],
            location: [],
            prod_codes: [],
            book_pen: true,
            book_com: true,
            filterChecked: false,
            filterValue: '',
            switch: false,
          })
        }
        this.FetchOffload(null, false)
      } else {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: data?.data?.message,
        })
      }
    }).catch(() => {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: constants.SERVER_CONNECTION_ERROR,
      })
      this.setState({ servererror: true })
    })
  }

  //PROCESS DATA ON EVENT
  processData = () => {
    let awb_array = []
    this.state.offload_list?.map((item) => {
      let obj = this.processIndividualRow(item)
      if (obj) {
        awb_array.push(obj)
      }
    })
    this.setState({
      offload_list: [],
      loading: false,
    }, () => this.setState({ offload_list: awb_array }))
  }
  //RESET
  resetPage = async () => {
    this.setState({
      visible: false,
      page: 1,
      offload_list: []
    })
  }
  //FETCH BUILD UP DATA
  FetchOffload = async () => {
    let temp_timestamp = moment().valueOf()
    this.setState({ latestTimestamp: temp_timestamp })
    let headers = {
      page: PAGE.offload_dashboard,
      station: this.state.station,
    }
    this.setState({ loading: true })
    let url = 'ofld_dash'
    await Http.get(url, { headers: headers }).then(resp => {
      if (this.state.latestTimestamp === temp_timestamp) {
        if (resp && resp.status === 200) {
          if (resp?.data?.data.length > 0) {
            this.setState({
              offload_list: resp?.data?.data,
              loading: false,
              // page: page+1
            }, () => {
              this.filter()
              window.scrollTo({
                top: 500,
                behavior: 'smooth',
              })
            })
          } else {
            this.setState({ loading: false })
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: resp?.data?.message,
            })
          }
        } else if (resp?.data?.status === 'error') {
          this.FetchOffload(null, false)
        }
      }
    }).catch(() => {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: constants.SERVER_CONNECTION_ERROR,
      })
      this.setState({
        loading: false,
        servererror: true
      })
    })
  }

  filter = () => {
    let data = cloneDeep(this.state.offload_list)
    let prodCodeList = []
    let locationList = []
    let destList = []
    if (data?.length > 0) {
      data?.map((item) => {
        if (item?.prod_code) {
          prodCodeList.push(item?.prod_code?.toUpperCase())
        }
        if (item?.location) {
          locationList.push(item?.location?.toUpperCase())
        }
        if (item?.dest) {
          destList.push(item?.dest?.toUpperCase())
        }
      })
    }
    prodCodeList = [...new Set(prodCodeList)]
    locationList = [...new Set(locationList)]
    destList = [...new Set(destList)]

    let filteredData = cloneDeep(this.state.offload_list)
    if (this.state.location && this.state.location.length > 0) {
      filteredData = filteredData?.filter((item) => item?.location?.toUpperCase() === this.state.location?.toUpperCase())
    }
    if (this.state.prod_codes && this.state.prod_codes?.length > 0) {
      filteredData = filteredData?.filter((item) => this.state.prod_codes?.includes(item?.prod_code?.toUpperCase()))
    }
    if (this.state.dest && this.state.dest.length > 0) {
      // eslint disable-next-line
      filteredData = filteredData?.filter((item) => this.state.dest && this.state.dest?.includes(item?.dest?.toUpperCase()))
    }

    if (this.state.searchValue && this.state.searchValue.length > 0) {
      filteredData = filteredData?.filter((item) => formatAWBNo(item.awb_no) == this.state.searchValue)
    }

    if (!this.state.book_pen && !this.state.book_com) {
      filteredData = []
    }
    if (!this.state.book_pen && this.state.book_com) {
      filteredData = filteredData?.filter((item) => item?.booked == true)
    }
    if (this.state.book_pen && !this.state.book_com) {
      filteredData = filteredData?.filter((item) => item?.booked == false)
    }

    if(this.state.filterChecked && this.state.filterValue) {
      // eslint-disable-next-line
      console.log('filterChecked', this.state.filterChecked, this.state.filterValue, this.state.switch)
      filteredData = filteredData?.filter((item) => {
        let date = moment().add(-this.state.filterValue, 'days').format('YYYY-MM-DD')
        let flight_date = moment(item?.flights_out?.flight_date).format('YYYY-MM-DD')
        if (!this.state.switch) {
          return flight_date <= date
        } else {
          return flight_date >= date
        }
      })
    }
          

    this.setState({
      prodCodeList,
      locationList,
      destList,
      filteredData
    })
  }

  //RENDER FILTER SELECTION STRING
  renderFilterBlock = () => {
    let prod_codes = this.state.temp_prod_codes?.length > 0 ? false : true
    let location = this.state.temp_location ? false : true
    if (this.state.wasSearched) {
      return (
        <><br />
          <Row className='mt-1vw pl-2vw sel-flt-rw'>
            <Col xs={12}><b> Search: </b><span>{this.state.searchValue}</span></Col> <></>
          </Row>
        </>
      )
    }
    return (
      <><br />
        <Row className='mt-1vw pl-2vw sel-flt-rw'>
          {!prod_codes ? <Col xs={12}><b> Product: </b><span>{this.state.temp_prod_codes?.toString()}</span></Col> : <></>}
          {!location ? <Col xs={12}><b> Location: </b><span>{this.state.temp_location}</span></Col> : <></>}
        </Row>
      </>
    )
  }
  //APPLY FILTER
  applyFilters = async () => {
    let offloaddash_filter = cloneDeep(this.state.offloadFilter) || {}
    offloaddash_filter[this.state.station] = {
      location: this.state.location,
      prod_codes: this.state.prod_codes,
      dest: this.state.dest,
      book_pen: this.state.book_pen,
      book_com: this.state.book_com,
      filterChecked: this.state.filterChecked,
      filterValue: this.state.filterValue,
      switch: this.state.switch,
    }
    let formdata = { offloaddash_filter: offloaddash_filter }
    await Http.put(`/page_filter/${this.state.user_id}`, formdata)
    this.filter()
  }
  //CLEAR FILTERS
  clearFilters = () => {
    this.setState({
      location: '',
      prod_codes: [],
      dest: [],
      offloadFilter: {},
      searchValue: '',
      wasSearched: false,
      searchSelect: false,
      filterChecked: false,
      filterValue: '',
      book_pen: true,
      book_com: true,
      switch: false,
    }, () => this.applyFilters())
  }
  //GET ADDITIONAL DAYS
  getAdditionalDays = (flight) => {
    if (moment.tz(flight.dept_time, this.state.timezone).diff(moment().tz(this.state.timezone), 'days') > 0) {
      return `+${moment.tz(flight.dept_time, this.state.timezone).diff(moment().tz(this.state.timezone), 'days')}`
    } else {
      return ''
    }
  }
  //REDIRECT LOGIC
  handleRedirect = () => {
    if (this.state.role?.toUpperCase() === 'WAREHOUSE TV') {
      logout()
    } else {
      pageHandler('', this.state.role)
    }
  }
  //HANDLE DONE
  done = (record) => {
    let data = cloneDeep(this.state.filteredData)
    let awb_index = data?.findIndex((p) => p.id === record?.id)
    if (awb_index > -1) {
      data[awb_index].done = true
      this.setState({ filteredData: [], }, () => {
        this.setState({ filteredData: data })
      }
      )
    }
  }
  //HANDLE CONFIRM
  confirm = async (record) => {
    // loading = true
    let offload_list = cloneDeep(this.state.filteredData)
    let index = offload_list?.findIndex((p) => p?.id === record.id)
    if (index > -1) {
      offload_list[index].loading = true
      this.setState({ FilteredData: offload_list })
    }

    await Http.post(`/ofld_awb/${record.id}`,
      { ofld_db_remark: document.getElementById(`ofld_remark_${record.id}`).innerText.trim()?.replace('\nConfirm', '') },
    )
  }

  // AWB SEARCH
  setSearchValue(e) {
    this.setState({ searchValue: e.target.value }, () => {
      if (this.state.wasSearched && !this.state.searchValue) {
        this.filter
      }
    })
  }
  onSearch = (e) => {
    let old_searchValue = cloneDeep(this.state.searchValue)
    let fetch_flag = false
    if (old_searchValue.trim() !== e.trim())
      fetch_flag = true
    if (!e) {
      this.setState({
        searchSelect: !this.state.searchSelect,
        searchValue: e
      }, () => {
        if (fetch_flag)
          this.filter()
      })
    }

    if (e) {
      //hallout_list
      this.filter()
    }
  }

  checkULDType = (uld) => {
    let type = ''
    if (uld?.blk && (!uld?.uld_no?.startsWith('C') && !uld?.uld_no?.endsWith('#'))) {
      type = 'BLK'
    } else {
      if (uld?.info?.remark?.toUpperCase()?.includes('SLU')) {
        type = 'SLU'
      } else if (!uld?.info?.remark?.toUpperCase()?.includes('SLU') && uld?.uld_dispo?.toUpperCase() !== 'BREAKDOWN' && uld?.master) {
        type = 'PTU'
      } else if (uld?.uld_no?.startsWith('C') || uld?.uld_no?.endsWith('#')) {
        type = 'CART'
      }
    }
    return type
  }

  render() {

    const awb_columns = [
      {
        title: 'AWB',
        dataIndex: '',
        key: 'awb_no',
        align: 'center',
        render: (_, record) => <span>{record?.awb_no ? formatAWBNo(record.awb_no) : 'N/A'}</span>
      },
      {
        title: 'Org',
        dataIndex: 'org',
        key: 'org',
      },
      {
        title: 'Dest',
        dataIndex: 'dest',
        key: 'dest',
      },
      {
        title: 'ULD',
        dataIndex: '',
        key: 'uld',
        align: 'center',
        render: (_, record) => {
          const type = this.checkULDType(record?.ulds_in)
          return <span className={type === 'BLK' ? '' : record?.uld_color}>
            {type === 'BLK' ? '-' : record.ulds_in.uld_no}
          </span>
        }
      },
      {
        title: 'PCS',
        dataIndex: '',
        key: 'pcs',
        render: (_, record) => (
          <span>{record?.inbound ? record?.avl_pcs : record?.awb?.pcs?.total?.value ? record?.awb?.pcs?.total?.value : 'N/A'}</span>
        )
      },
      {
        title: 'WGT',
        dataIndex: 'wgt',
        key: 'wgt',
        render: (_, record) => {
          let weight_kg = ['LBS', 'L', 'LBR', 'LB'].includes(record?.wgt?.unit) ? weightCalculator(record?.wgt?.value, 'LBS') : record?.wgt?.value
          let weight_lbs = ['KG', 'K', 'KGM'].includes(record?.wgt?.unit) ? weightCalculator(record?.wgt?.value, 'KGM') : record?.wgt?.value
          return <span>{this.state.weight_unit === 'KG' ?
            formatWeightString(weight_kg, 'KG') :
            formatWeightString(weight_lbs, 'LBS')}
          </span>
        }

      },
      {
        title: 'LOCN',
        dataIndex: '',
        key: 'locn',
        render: (_, record) => (
          <span className={record?.location_color}>
            {record?.location ? record.location : !record?.inbound ? record?.flights_in?.flight_no : 'N/A'}
          </span>
        ),
      },
      {
        title: 'PROD',
        dataIndex: '',
        key: 'prod',
        render: (_, record) => (
          <span>{record?.prod_code ? record.prod_code : 'N/A'}</span>
        ),
      },
      {
        title: 'FLT',
        dataIndex: 'flt',
        key: 'flt',
        align: 'left',
        render: (_, record) => (
          <span>{record?.flights_out?.flight_no + '/' + moment(record?.flights_out?.flight_date).format('DDMMMYY').toUpperCase()}</span>
        )
      },
      {
        title: 'Gate',
        dataIndex: 'gate',
        key: 'gate',
        render: (_, record) => (
          <span>
            {record?.flights_out?.dept?.gate ? `${record.flights_out.dept.gate}` : 'N/A'}
          </span>
        )
      },
      {
        title: 'Fre',
        dataIndex: 'ofld_count',
        key: 'ofld_count',
      },
      {
        title: 'Done',
        dataIndex: 'done',
        key: 'done',
        className: 'no-print',
        render: (_, record) => (
          <>
            {
              !record?.done ?
                <><Button onClick={() => this.done(record)} type='primary' className='warehouse-done'>Done</Button></> :
                <div id={`ofld_remark_${record.id}`} className='fv-middle'>
                  <Form.Item className='product-select'>
                    <Select
                      size='small'
                      placeholder='Select product'
                      popupClassName='warehouse-select product-select-option'
                    >
                      <Option value={'Rebooked'}>{'Rebooked'}</Option>
                      <Option value={'Departed'}>{'Departed'}</Option>
                    </Select>
                  </Form.Item>

                  <Button type='text' onClick={() => this.confirm(record)} loading={record.loading} icon={record.loading ? '' :  <img src={confirmIcon} alt='Confirm' />} 
                    className='product-confirm'
                  />
                </div>
            }
          </>
        )
      }
    ]
    return (
      <div className='warehouse-screen buildup-dash'>
        <div className='text-right f-spacebtw'>
          <div className='no-print'>
            {this.state.role?.toUpperCase() === 'WAREHOUSE TV' ?
              <div className='d-flex'>
                {
                  this.state.logintype && this.state.logintype === 'DashTV' ? null :
                    <div className='mr-1vw'>
                      <Button className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<ArrowLeftOutlined />} size='large' onClick={() => window.location.href = '/landing-page'} />
                      <p className='btn-text'>Back</p>
                    </div>
                }
                <div>
                  <Button className='custom-icon-button warehouse-filter rotate-180' type='primary' shape='circle' icon={<LogoutOutlined />} size='large' onClick={this.handleRedirect} />
                  <p className='btn-text'>Signout</p>
                </div>
              </div>
              :
              <div>
                <Button className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<HomeOutlined />} size='large' onClick={this.handleRedirect} />
                <p className='btn-text'>Home</p>
              </div>
            }
          </div>
          <h1 className='dash-title mr-0 dash-loc'>{this.state.station}</h1>
        </div>
        <div className='clock-container'>
          <Text className='clock-text'>
            {this.state.clock}
          </Text>
        </div>
        <h1 className='text-center'><span className='dash-title'>OFF-Load Dashboard</span></h1>
        <Row
          gutter={[
            {
              xs: 0,
              sm: 0,
              md: 0,
              lg: 0,
            },
            {
              xs: 0,
              sm: 0,
              md: 0,
              lg: 0,
            },
          ]}
        >
          <div className='w-100 f-spacebtw mb-1p5'>
            <div className='d-flex flex-6'>
              <div className='selected-filter mb-0 '>Selected Filters:
                {this.renderFilterBlock()}
              </div>
            </div>
            <div span={2} className='row-1 pr-0 ml-auto bd-btns flex-1 no-print'>
              <Space direction='horizontal' className='w-action-btn'>
                <Input.Search
                  placeholder='Search AWB'
                  onSearch={this.onSearch}
                  onChange={(e) => this.setSearchValue(e)}
                  allowClear
                  className={'warehouse-search' + (this.state.searchSelect ? ' search-w100' : ' search-w0')}
                />
                <Button className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<PrinterOutlined />} size='large' onClick={() => window.print()} />
                <Button disabled={this.state.wasSearched} className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<FilterOutlined />} size='large' onClick={this.showDrawer} />
              </Space>
            </div>
          </div>
          <Drawer
            title=''
            placement='top'
            width={500}
            closable={false}
            open={this.state.visible}
            className='warehouse-drawer dr-buildup tv-res'
          >
            <Row>
              <Button className='close-btn ml-auto' onClick={this.onClose} size='large' type='link'>X</Button>
            </Row>
            <Row
              gutter={[
                {
                  xs: 0,
                  sm: 0,
                  md: 0,
                  lg: 0,
                },
                {
                  xs: 0,
                  sm: 0,
                  md: 0,
                  lg: 0,
                },
              ]}
              className='warehouse-screen'
            >
              <Col xs={24} sm={24} md={12} lg={10} xl={10} className='row-1'>
                <Form.Item label='Product'>
                  <Select
                    mode='multiple'
                    size='small'
                    value={this.state.prod_codes}
                    placeholder='Select product'
                    dropdownClassName='warehouse-select'
                    onChange={(e) => this.setState({ prod_codes: e?.includes('RESET') ? [] : e })}
                  >
                    <Option className='blue' key={'RESET'} value={'RESET'}>{'RESET'}</Option>
                    {this.state.prodCodeList?.map((item) => (
                      <Option key={item} value={item}>{item}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6} xl={7} className='row-1'>
                <Form.Item label='Location' className='loc-search'>
                  <Select
                    allowClear
                    showSearch
                    size='small'
                    value={this.state.location}
                    placeholder='Select location'
                    dropdownClassName='warehouse-select'
                    onChange={(e) => this.setState({ location: e && e !== undefined ? e : '' })}
                  >
                    {this.state.locationList?.map((item) => (
                      <Option key={item} value={item}>{item}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6} xl={7} className='row-1'>
                <Form.Item label='Destination'>
                  <Select
                    mode='multiple'
                    size='small'
                    value={this.state.dest}
                    placeholder='Select Destination'
                    dropdownClassName='warehouse-select'
                    onChange={(e) => this.setState({ dest: e?.includes('RESET') ? [] : e })}
                  >
                    <Option className='blue' key={'RESET'} value={'RESET'}>{'RESET'}</Option>
                    {this.state.destList?.map((item) => (
                      <Option key={item} value={item}>{item}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={10} className='space-nowrap ml-neg8'>
                <div className='tv-res'>
                  <label className='transparent'>-</label>
                  <Form.Item>
                    <Checkbox>
                      Show AWBs with
                      <InputNumber
                        className='small-input pl-2 uld-time'
                        controls={false}
                        min={0}
                      />
                      <span className='pl-1'> days or more</span>
                    </Checkbox>
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6} xl={6} className='dash-checkbox'>
                <Form.Item label='Booking Status'>
                  <Checkbox checked={this.state.book_pen} onChange={(e) => this.setState({ book_pen: e.target.checked })}>Pending</Checkbox>
                  <Checkbox checked={this.state.book_com} onChange={(e) => this.setState({ book_com: e.target.checked })}>Completed</Checkbox>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={11} xl={11} className='space-nowrap ml-neg8'>
                <div className='tv-res'>
                  <label className='transparent'>-</label>
                  <Form.Item>
                    <Checkbox
                      onChange={(e) => this.setState({
                        filterChecked: e.target.checked,
                        filterValue: e.target.checked === false ? '' : this.state.filterValue,
                      })}
                      checked={this.state.filterChecked}
                    >
                      Show ULDs with
                      <InputNumber
                        className='small-input pl-2 uld-time'
                        disabled={!this.state.filterChecked}
                        onChange={(e) => this.setState({ filterValue: e })}
                        controls={false}
                        min={0}
                        value={this.state.filterValue}
                      />
                      <span className='pl-1'> Day or</span>
                      <Switch
                        className='uld-switch warehouse-switch ml-2vw'
                        style={{ backgroundColor: '#0a1227' }}
                        disabled={!this.state.filterChecked}
                        onChange={(e) => this.setState({ switch: e })}
                        checked={this.state.switch}
                        unCheckedChildren='more'
                        checkedChildren='less'
                        size='default'
                      />
                    </Checkbox>
                  </Form.Item>
                </div>
              </Col>
              <Col className='ml-auto mt-2vw'>
                <Space direction='horizontal'>
                  <Button onClick={this.clearFilters} type='primary' className='custom-button warehouse-button mr-2vw'>Clear filters</Button>
                  <Button onClick={() => this.applyFilters()} className='custom-button warehouse-button' type='primary'>Apply filters</Button>
                </Space>
              </Col>
            </Row>
          </Drawer>
          {/* <div className='clock-container'>
            <Text className='clock-text'>
              {this.state.clock}
            </Text>
          </div> */}
          <Col xs={24} sm={24} md={24} lg={24} className=''>
            <Spin spinning={this.state.loading}>
              <Table
                className='components-table-demo-nested warehouse-table'
                columns={awb_columns}
                dataSource={this.state.filteredData}
                pagination={false}
                rowKey='id'
                rowClassName={(record) => {
                  if (this.state.awb_ids.includes(record.id)) {
                    return 'amber-ho-bg'
                  }
                }}
                onRow={() => {
                  return { style: { fontSize: `${this.state.tableBodyFontSize === null || this.state.tableBodyFontSize === 'null' ? this.state.defaultFontSize : `${this.state.tableBodyFontSize}vw`}` }, }
                }}
                onHeaderRow={() => {
                  return { style: { fontSize: `${this.state.tableBodyFontSize === null || this.state.tableBodyFontSize === 'null' ? this.state.defaultFontSize : `${this.state.tableBodyFontSize}vw`}`, }, }
                }}
              />
            </Spin>
          </Col>
        </Row>
      </div>
    )
  }
}

export default OfldDashboard
